"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  name: 'DailyHistoryTable',
  props: {
    data: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return date ? _moment.default.utc(date).format('DD/MM/YYYY') : '—-';
    },
    formatTime: function formatTime(date) {
      return date ? (0, _moment.default)(date).format('HH:mm') : '--:--';
    },
    formatSeconds: function formatSeconds(seconds) {
      var totalMinutes = Math.floor(seconds / 60);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = String(totalMinutes % 60).padStart(2, '0');
      return "".concat(hours, ":").concat(minutes);
    }
  }
};